<template>
  <div>
    <Head :title="__('Configuration du compte')" />

    <div class="flex items-center justify-between mb-6">
      <h1 class="text-xl font-semibold text-gray-800">{{ account.name }} - {{ __('Configuration') }}</h1>
      <Link v-if="!is_system_admin" :href="route('account.config.create')" class="btn-indigo">
        {{ __('Nouveau') }}
      </Link>
    </div>

    <div class="overflow-x-auto bg-white rounded-md shadow">
      <table class="w-full whitespace-nowrap">
        <tbody>
          <tr class="font-bold text-left">
            <th v-if="is_system_admin" class="px-6 pt-6 pb-4">{{ __('Compte') }}</th>
            <th class="px-6 pt-6 pb-4">{{ __('Clé') }}</th>
            <th class="px-6 pt-6 pb-4">{{ __('Valeur') }}</th>
            <th class="px-6 pt-6 pb-4" :colspan="is_system_admin ? 1 : 2"></th>
          </tr>
          <tr v-for="config in configs" :key="config.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
            <td v-if="is_system_admin" class="border-t">
              <span class="flex items-center px-6 py-4 text-sm text-gray-500">
                {{ config.account_name ?? '-' }}
              </span>
            </td>
            <td class="border-t">
              <span class="flex items-center px-6 py-4 font-mono text-sm text-gray-700">
                {{ config.key }}
              </span>
            </td>
            <td class="border-t">
              <span class="flex items-center px-6 py-4 text-sm text-gray-500 max-w-xs truncate">
                <span v-if="revealed[config.id]">{{ config.value }}</span>
                <span v-else class="tracking-widest text-gray-400">••••••••••••</span>
              </span>
            </td>
            <td class="border-t">
              <button
                type="button"
                class="px-4 py-4 text-gray-400 hover:text-gray-600"
                @click="toggleReveal(config.id)"
                :title="revealed[config.id] ? 'Masquer' : 'Afficher'"
              >
                <svg v-if="!revealed[config.id]" class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M15 12a3 3 0 11-6 0 3 3 0 016 0zM2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                </svg>
                <svg v-else class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21" />
                </svg>
              </button>
            </td>
            <td v-if="!is_system_admin" class="w-px border-t">
              <div class="flex items-center gap-2 px-4 py-4">
                <Link :href="route('account.config.edit', config.id)" class="text-indigo-500 hover:text-indigo-700 text-sm">
                  {{ __('Modifier') }}
                </Link>
                <button
                  type="button"
                  class="text-red-400 hover:text-red-600 text-sm"
                  @click="destroy(config)"
                >
                  {{ __('Supprimer') }}
                </button>
              </div>
            </td>
          </tr>
          <tr v-if="configs.length === 0">
            <td class="px-6 py-4 border-t text-gray-400" :colspan="is_system_admin ? 3 : 4">Aucune configuration.</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { Head, Link, router } from '@inertiajs/vue3'
import Layout from '@/Shared/Layout'

export default {
  components: { Head, Link },
  layout: Layout,

  props: {
    account: Object,
    configs: Array,
    is_system_admin: Boolean,
  },

  data() {
    return {
      revealed: {},
    }
  },

  methods: {
    toggleReveal(id) {
      this.revealed[id] = !this.revealed[id]
    },
    destroy(config) {
      if (confirm(`Supprimer la clé "${config.key}" ?`)) {
        router.delete(this.route('account.config.destroy', config.id))
      }
    },
  },
}
</script>
